module.exports = __webpack_public_path__ + "static/media/details-icon-one.56bede37.svg";